import PropTypes from "prop-types";
import TableAction from "../TableAction/TableAction";
import {useHistory} from "react-router";
import {USERS_MANAGEMENT_PAGE} from "../../utils/routeNames";
import {useDispatch} from "react-redux";
import {requestHandler} from "../../infrastructure/requestHandler";
import {useState} from "react";
import {ChangeUserActivityStatus, DeleteUser, UpdateUser, ViewUser} from "../../actions/UserActions";
import {useTranslation} from "react-i18next";

function fillAction(key, label, handleClickEvent) {
    return {key, label, handleClickEvent};
}

function UserTableActions(props) {

    const dispatch = useDispatch();
    const history = useHistory();

    const [anchor, setAnchorEl] = useState(false);
    const {t} = useTranslation();

    const handleUserViewAction = (id) => {
        dispatch(ViewUser());
        history.push(USERS_MANAGEMENT_PAGE + `/${id}`);
    }

    const handleUserEditAction = (id) => {
        dispatch(UpdateUser());
        history.push(USERS_MANAGEMENT_PAGE + `/${id}`);
    }

    const handleUserActivityChangeAction = async (id) => {
        await requestHandler(ChangeUserActivityStatus(id, !props.isBlocked), dispatch);
        props.setParentState(!props.parentState);
        setAnchorEl(null);
    }

    const handleUserDeleteAction = async (id) => {
        await requestHandler(DeleteUser(id), dispatch);
        props.setParentState(!props.parentState);
        setAnchorEl(null);
    }

    let userActions = [];

    if (props.isBlocked === true) {
        userActions.push(fillAction("changeActivity", t("USERS_TABLE_ACTIONS_UNLOCK"), () => handleUserActivityChangeAction(props.userId)));
    } else {
        userActions.push(fillAction("view", t("USERS_TABLE_ACTIONS_VIEW"), () => handleUserViewAction(props.userId)));
        userActions.push(fillAction("edit", t("USERS_TABLE_ACTIONS_EDIT"), () => handleUserEditAction(props.userId)));
        userActions.push(fillAction("changeActivity", t("USERS_TABLE_ACTIONS_BLOCK"), () => handleUserActivityChangeAction(props.userId)));
        userActions.push(fillAction("delete", t("USERS_TABLE_ACTIONS_DELETE"), () => handleUserDeleteAction(props.userId)));
    }

    return (
        <TableAction anchor={anchor}
                     setAnchorEl={setAnchorEl}
                     actionItems={userActions}/>
    )
}

UserTableActions.propTypes = {
    userId: PropTypes.string.isRequired,
    isBlocked: PropTypes.bool.isRequired,
    setParentState: PropTypes.func,
    parentState: PropTypes.bool
}

export default UserTableActions;